<template>
  <AppTopicsHeader />
</template>
